import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./style/base.scss";
import "element-ui/lib/theme-chalk/index.css";
import { Carousel, CarouselItem, Backtop } from "element-ui";

Vue.prototype.$ELEMENT = { size: "small", zIndex: 3000 };
Vue.use(Backtop);
Vue.use(Carousel);
Vue.use(CarouselItem);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
